import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Endpoints } from '../../Global/Endpoints';
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";

const HealthPlan = ({ nextStep, prevStep, formData, setFormData, handleHealthPlanChange, handleSubmit, emailid, isSubmitting, error, setErrors,isEdit,step, totalSteps, isHighmarkPortal}) => {
  const [loading, setLoading] = useState(true);
  const [options, setOptions] = useState([]);
  const [isNextEnabled, setNextEnabled] = useState(false);
  const [isCompleteProfileEnabled, setCompleteProfileEnabled] = useState(false);
  const userInfo = useSelector((state) => state.userData);
  const { t } = useTranslation();
  
  useEffect(() => {
    const params = { EmailID: userInfo.userData.EmailID || emailid, DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal" };

    setLoading(true);
    axios
      .post(
        Endpoints.AppWhyHere,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`,
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      )
      .then((response) => {
        setOptions(response.data);

        // Ensure formData.healthPlans is set correctly as a string, not an array
        if (Array.isArray(formData.healthPlans) && formData.healthPlans.length > 0) {
          setFormData((prev) => ({
            ...prev,
            healthPlans: formData.healthPlans[0], // Extract first element
          }));
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [emailid]);

  // Check selected value on load and update button states
  useEffect(() => {
    const selectedPlan = Array.isArray(formData.healthPlans) ? formData.healthPlans[0] : formData.healthPlans || ""; // Ensure string

    if (selectedPlan === t('supportmsg')) {
      setNextEnabled(true);
      setCompleteProfileEnabled(false);
    } else if (selectedPlan === t('pregnancysupport')) {
      setNextEnabled(true);
      setCompleteProfileEnabled(false);
    } else if (selectedPlan) {
      setNextEnabled(false);
      setCompleteProfileEnabled(true);
    } else {
      setNextEnabled(true);
      setCompleteProfileEnabled(false);
    }
  }, [formData.healthPlans]);

  const handleRadioChange = (e) => {
    const value = e.target.value;

    if (handleHealthPlanChange) {
      handleHealthPlanChange(value);
    } else {
    setFormData((prev) => ({
      ...prev,
      healthPlans: value, // Ensure stored as string
    }));
    }

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value) {
        delete newErrors.healthPlans;
      }
      return newErrors;
    });
  };

   if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

  return (
    <>
      <div>
      <h3 className="page-heading-secondary-black-500 mb-5">
  {isEdit ? (isHighmarkPortal ? t('healthplanupdatehlhighmark') : t('healthplanupdatehl'))
        : (isHighmarkPortal ? t('healthplancraetehlhighmark') : t('healthplancraetehl'))}
</h3>
<p> {isEdit ? (isHighmarkPortal ? t('healthplanupdateshighmark') : t('healthplanupdatesh'))
        : (isHighmarkPortal ? t('healthplancraeteshighmark') : t('healthplancraetesh'))}</p>

        {options.map((option, index) => (
          <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper" key={index}>
            <input
              type="radio"
              className="form-check-input radio-btn win-form-check-input"
              value={option.AppWhyHere}
              checked={(Array.isArray(formData.healthPlans) ? formData.healthPlans[0] : formData.healthPlans) === option.AppWhyHere} // Fix checked logic
              onChange={handleRadioChange}
            />
            <label className="multistep-form-radio-checkbox-label">{option.AppWhyHere}</label>
          </div>
        ))}
      </div>

      {error && <p className="text-danger">{error}</p>}
      <div className="mt-5">
      {isHighmarkPortal ? (
        <div className="pagination-wrapper mt-5 extra-margin-bottom-120px-in-mobile">
          <button className="previous-btn" onClick={prevStep}></button>
          <span className="me-3">{step} of {totalSteps}</span>

          {!isCompleteProfileEnabled ? (
            <button className="next-btn" onClick={nextStep} disabled={!isNextEnabled}></button>
          ) : (
            <button className="next-btn" onClick={handleSubmit} disabled={isSubmitting}></button>
          )}
        </div>
      ) : (
        <div className="mt-5"  style={{paddingBottom : 25}}>
          <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={prevStep}>
            {t('back')}
          </button>
          {!isCompleteProfileEnabled ? (
            <button className="win-btn-primary mobile-view" onClick={nextStep} disabled={!isNextEnabled}>
              {t('next')}
            </button>
          ) : (
            <button className="win-btn-primary mobile-view" onClick={handleSubmit} disabled={isSubmitting}>
              {t('healthprofile')}
            </button>
          )}
        </div>
      )}
      </div>
    </>
  );
};

export default HealthPlan;
